import _axios from "../../index";

//退出登录
export const userLogout = () =>
    _axios({
        url: "/logout",
        method: "post"
    });

// 通过token获取用户信息.
export const apiMe = () =>
    _axios({
        url: "/me",
        method: "post"
    });


export const bannerList = () =>
    _axios({
        url: "/banner/search",
        method: "get"
    });

export const statisticsCount = () =>
    _axios({
        url: "/statistics/evidenceCount",
        method: "get"
    });